import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Observable, of} from 'rxjs';
import {CarrosselItem} from '../model/carrossel';

@Injectable({
  providedIn: 'root',
})
export class CarrosselService {
  constructor(private sanitizer: DomSanitizer) {}
  getCarrosselSite(): Observable<CarrosselItem[]> {
    return of([
      {
        imageUrlBanner1: '../../../../../assets/app-assets/images/site/banner-1-2024.png',
        imageIconeBanner1: '../../../../../assets/app-assets/images/icones-geia/poligono.png',
        titleTextPart1CimaBanner1: 'ADMINISTRADORA',
        titleTextPart1BaixoBanner1: 'ESPECIALIZADA',
        titleTextPart2Banner1: 'EM BENEFÍCIOS',
        paragraphTextPart1Banner1: 'Gestão de benefícios em saúde para',
        paragraphTextPart2Banner1: 'empresas e entidades de classe.',
        mostrarBanner: true,
      },
      {
        imageUrlBanner2: '../../../../../assets/app-assets/images/site/banner-2-2024.png',
        imageIconeBanner2: '../../../../../assets/app-assets/images/icones-geia/Retângulo 135.png',
        titleTextPart1CimaBanner2: 'CONSULTORIA',
        titleTextPart1BaixoBanner2: 'E CORRETORA',
        titleTextPart2Banner2: 'DE SEGUROS',
        paragraphTextPart1Banner2: 'Especializada gestão de benefícios em',
        paragraphTextPart2Banner2: 'saúde e seguros para pessoas e empresas.',
        mostrarBanner: true,
      },
      {
        imageUrlBanner3: '../../../../../assets/app-assets/images/site/banner-3-2024.png',
        imageIconeBanner3: '../../../../../assets/app-assets/images/icones-geia/Retângulo 135.png',
        titleTextPart1CimaBanner3: 'HÁ MAIS DE',
        titleTextPart1CimaNegritoBanner3: '25 ANOS,',
        titleTextPart1BaixoBanner3: 'DEDICADA EM',
        titleTextPart2Banner3: 'GESTÃO DE BENEFICÍOS',
        paragraphTextPart1CimaNegritoBanner3: 'Promoção da Saúde:',
        paragraphTextPart1CimaBanner3: 'Incentivamos hábitos',
        paragraphTextPart1BaixoBanner3: 'saudáveis para melhorar a vida.',
        paragraphTextPart2CimaNegritoBanner3: 'Gestão Financeira Eficiente:',
        paragraphTextPart2CimaBanner3: 'Controlamos os',
        paragraphTextPart2CentroBanner3: 'custos de saúde da empresa com cuidados',
        paragraphTextPart2BaixoBanner3: 'preventivos e monitoramento.',
        mostrarBanner: true,
      },
      {
        imgBannerImpostoRenda: '../../../../assets/app-assets/images/site/informe-rendimento-2025.png',
        tituloImpostoRenda: 'INFORME DE RENDIMENTOS   ',
        anoCalendarioImpostoRenda: '2025',
        descricacaoImpostoRenda1: 'Seu informe de rendimentos<br>já está disponível!*',
        descricaoImpostoRenda2: '*Beneficiários da Uniodonto:',

        descricaoImpostoRenda3:
          'Para acessar seu informe de rendimentos entre em <br> contato diretamente com a Uniodonto.',
        mostrarBanner: true,
      },
      {
        aviso: '../../../../../assets/app-assets/images/site/erro-whats.jpg',
        avisoMobile: '../../../../../assets/app-assets/images/site/erro-whats-mobile.png',
        mostrarBanner: false,
      },
    ]);
  }
}
